/**
 * Execution Plan Engine — 唯一决定执行顺序的出口
 *
 * TodayDecision → ExecutionPlan
 * 不做新业务判断，只编排 queue。
 */
import type { ExecutionJob, ExecutionPlan, TodayDecision } from './types';

const DEFAULT_ORDER: Array<{ type: ExecutionJob['type']; blocking: boolean; required: boolean }> = [
  { type: 'photo', blocking: true, required: true },
  { type: 'short_video', blocking: false, required: false },
  { type: 'voice', blocking: false, required: false },
  { type: 'talking_video', blocking: false, required: true },
];

/**
 * 从 TodayDecision 生成执行计划
 * 仅读取 decision.materials，不引入第二套 if 判断
 */
export function buildExecutionPlan(decision: TodayDecision): ExecutionPlan {
  const queue: ExecutionJob[] = [];
  let order = 1;

  for (const spec of DEFAULT_ORDER) {
    const slot = decision.materials[spec.type];
    if (!slot.enabled || slot.count <= 0) continue;

    queue.push({
      order: order++,
      type: spec.type,
      required: spec.required,
      blocking: spec.blocking,
      retry: 1,
      reason: slot.reason,
    });
  }

  return { queue };
}

/** 是否需要先完成 voice 再跑 talking_video（由 queue 顺序保证，不额外 if） */
export function executionPlanSummary(plan: ExecutionPlan): string {
  if (plan.queue.length === 0) return '今日无素材执行任务（休息或策略关闭）';
  return plan.queue.map((j) => `${j.order}. ${j.type}（${j.reason}）`).join('；');
}
